// extracted by mini-css-extract-plugin
export default {"progressContainer":"ProgressBar_progressContainer__VZTw1","progressBar":"ProgressBar_progressBar__5X2M7"};